import { render, staticRenderFns } from "./CreateUpdateModal.vue?vue&type=template&id=22ba08e6"
import script from "./CreateUpdateModal.vue?vue&type=script&lang=js"
export * from "./CreateUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports